import "./UserManagementComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {CommonService} from "../../shared/services";
import {IAPIResponseType} from "../../shared/models/api.model";
import SearchComponent from "../../shared/components/search/SearchComponent";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import commonService from "../../shared/services/common.service";
import {Link} from "react-router-dom";
import {Download} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import UserManagementListComponent from "./user-management-list/UserManagementListComponent";
import UserFiltersComponent from "./user-filters/UserFiltersComponent";

interface UserManagementComponentProps {

}

const FiltersInitialState: any = {
    search: '',
    genders: [],
    gendersObjs: [],
    roleIds: [],
    roleObjs: [],
    startDate: '',
    endDate: ''
};

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['userObjs', 'gendersObjs', 'roleObjs'];


const UserManagementComponent = (props: UserManagementComponentProps) => {
    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const [userAddPermissions, setUserAddPermissions] = useState(false);


    useEffect(() => {
        dispatch(setCurrentNavParams("User", "User"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._testOrder.downloadTestOrderCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'userList', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
            };
            if (queryParamData?.genders?.length) {
                data['genders'] = queryParamData?.genders.split(',') || [];
            }
            data['gendersObjs'] = CommonService._staticData.genderOptions?.filter((item: any) => data['genders']?.includes(item?.code));

            if (queryParamData?.userIds?.length) {
                data['roleIds'] = queryParamData?.userIds.split(',') || [];
            }
            data['roleObjs'] = queryParamData?.userIds ? queryParamData?.userIds.split(',') : [];

            setFilterData(data);
        }
    }, [queryParamData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        setUserAddPermissions(commonService.checkAccess('User',
            "addUser", currentUser?.userAccessModules))
    }, [currentUser]);


    return (
        <div className={'user-management-component screen'}>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search"}
                                id="search_input"
                                placeholder={"Search using User Name"}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {
                                CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    className={"clear-all-filters"}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }

                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                commonService.checkAccess('User', 'userCsvDownload', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    variant={"contained"}
                                    fullWidth={false}
                                    handleClick={downloadCSV}
                                    isLoading={isCSVDownloading}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }

                            {/*{*/}
                            {/*    commonService.checkAccess('User', 'userAdd', currentUser?.userAccessModules) &&*/}
                            {
                                userAddPermissions && <Link to={CommonService._routeConfig.AddUserRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_user_btn"
                                        startIcon={<AddIcon/>}
                                    >
                                        New User
                                    </ButtonComponent>
                                </Link>
                            }
                            {/*}*/}
                        </div>
                    </div>
                    <>
                        <UserManagementListComponent
                            filterData={filterData}
                            isColumnFilterVisible={true}
                        />
                    </>
                </div>
            </div>
            <DrawerComponent open={showFilterDrawer}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <UserFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                      clearAllFilters={clearAllFilters}
                />
            </DrawerComponent>
        </div>
    );

};

export default UserManagementComponent;
